import { useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export function RejectModal({ docId, onDone, onCancel }) {
  const [reason, setReason] = useState("");
  const confirm = async () => {
    try {
      await api.patch(`/documents/${docId}`, { status: "rejected", admin_remark: reason });
      toast.success("Rejected");
      onDone();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white border border-slate-200 p-6 w-full max-w-md space-y-4">
        <h3 className="font-display text-xl font-bold">Reject with reason</h3>
        <textarea required rows={3} placeholder="Reason the tenant can see…" data-testid="reject-reason"
                  className="border border-slate-300 px-4 py-2.5 w-full"
                  value={reason} onChange={(e) => setReason(e.target.value)} />
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="bg-slate-100 px-5 py-2">Cancel</button>
          <button onClick={confirm} data-testid="confirm-reject"
                  className="bg-red-600 text-white px-5 py-2 hover:bg-red-700">Reject</button>
        </div>
      </div>
    </div>
  );
}
